import { useCallback, useEffect, useState } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import ReactGA from 'react-ga4';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import './checkout.scss';
import CustomButton from "../../uiKit/Button/CustomButton";

import {
    ourBalancePaymentIntent,
    ourBalancePaymentIntentSaved
} from "../../redux/state/paymentSlice";
import { setCommunityThankOpen, setStripeOpen } from "../../redux/state/donationSlice";

const CheckoutOurBalance = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const { communityId } = useParams();

    const savedCard = useSelector(state => state.payment.savedCard, shallowEqual);
    const isLoadingOurBalanceIntent = useSelector(state => state.payment.isLoading.ourBalancePaymentIntent, shallowEqual);
    const error = useSelector(state => state.payment.error, shallowEqual);
    const body = useSelector(state => state.donation.body, shallowEqual);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!!error?.errors?.Amount) {
            toast.info(error.errors.Amount[0] ?? 'something went wrong');
        }
    }, [error])

    useEffect(() => {
        if (!communityId) return;
        dispatch(ourBalancePaymentIntent({
            body,
            communityId,
        }))
    }, [body, communityId, dispatch])

    const payWithSavedCard = useCallback(() => {
        ReactGA.event(`donate_${pathname.split('/')[1].replace('-', '_')}_with_saved_card_checkout`);
        setIsLoading(true);
        dispatch(ourBalancePaymentIntentSaved({
            communityId: body.incomingBalanceId,
            paymentMethodId: savedCard.id,
            body: body
        }))
            .then(unwrapResult)
            .then((response) => {
                if (response.status === 'Success') {
                    dispatch(setStripeOpen(false));
                    dispatch(setCommunityThankOpen(true));
                } else {
                    toast.info(response.errorMessage ?? response.errorMessage ?? 'Something went wrong.')
                }
            })
            .catch(({ title }) => {
                toast.info(`Payment failed: ${title}`)
            })
            .finally(() => setIsLoading(false));
    }, [body, dispatch, pathname, savedCard.id])

    return (
        <CustomButton
            title='Donate'
            onClick={payWithSavedCard}
            style={{ marginTop: '16px' }}
            disabled={isLoading || isLoadingOurBalanceIntent}
            loading={isLoading || isLoadingOurBalanceIntent}
        />
    )
}

export default CheckoutOurBalance;